/**
 * Fan agent admin API.
 *
 * Dugout-be, not the chat module. Dev is test-api.dugoutlive.com and prod
 * is prod-api-v2.dugoutlive.com, chosen by the Dev/Prod switch in AppConfig.
 */
import { BASE_URL } from '../components/AppConfig';
import { getBearerToken } from '../utils/authToken';

function getAuthHeaders() {
    const token = getBearerToken();
    if (!token) return {};
    return { Authorization: token };
}

async function handleResponse(res) {
    if (!res.ok) {
        let errorMsg = `Request failed: ${res.status}`;
        try {
            const body = await res.json();
            errorMsg = body.message || body.error || errorMsg;
        } catch { /* keep the status line */ }
        throw new Error(errorMsg);
    }
    const body = await res.json().catch(() => ({}));
    return body.data ?? body;
}

const base = () => `${BASE_URL}/admin/fan-agents`;

export async function getFanAgentHealth() {
    const res = await fetch(`${base()}/health`, {
        credentials: 'include',
        headers: getAuthHeaders(),
    });
    return handleResponse(res);
}

export async function getFanAgentLive() {
    const res = await fetch(`${base()}/live`, {
        credentials: 'include',
        headers: getAuthHeaders(),
    });
    return handleResponse(res);
}

export async function getFanAgentPosts({ day, agentId, scenario } = {}) {
    const qs = new URLSearchParams();
    if (day) qs.set('day', day);
    if (agentId) qs.set('agent_id', agentId);
    if (scenario) qs.set('scenario', scenario);
    const res = await fetch(`${base()}/posts?${qs.toString()}`, {
        credentials: 'include',
        headers: getAuthHeaders(),
    });
    return handleResponse(res);
}
